import React, { useState } from 'react';
import api from '../api';

const ProductImport = ({ fecharModal }) => {
    const [file, setFile] = useState(null);
    const [importando, setImportando] = useState(false); // Corrigido

    const handleFileChange = (e) => {
        setFile(e.target.files[0]);
    };

    const handleUpload = async () => {
        if (!file) {
            alert("Selecione um arquivo Excel/CSV para importar!");
            return;
        }

        const formData = new FormData();
        formData.append('file', file);

        try {
            setImportando(true);
            const response = await api.post('/produtos/importar', formData, {
                headers: { 'Content-Type': 'multipart/form-data' }
            });

            alert(response.data.mensagem);
            fecharModal();  // 🔹 Fecha o modal automaticamente após a importação
        } catch (error) {
            alert("Erro ao importar produtos. Verifique o arquivo e tente novamente.");
        } finally {
            setImportando(false);
        }
    };
    
    return (
        <div className="fixed inset-0 flex justify-center items-center bg-black bg-opacity-50">
            <div className="bg-white p-6 rounded-lg shadow-lg w-full max-w-lg relative">
                
                {/* 🔹 Botão para fechar o modal */}
                <button 
                   className="absolute top-4 right-4 text-gray-600 hover:text-gray-800"
                   onClick={fecharModal} // 🔹 Agora chama corretamente a função
                >
                    ✖
                </button>

                <h2 className="text-2xl font-semibold text-center text-gray-700 mb-6">
                    Importar Produtos
                </h2>

                {/* 🔹 Botão de Download do Modelo */}
                <div className="mb-4">
                    <a 
                        href="/modelo_importacao_produtos.xlsx" 
                        download 
                        className="bg-gray-200 text-gray-800 px-4 py-2 rounded-lg hover:bg-gray-300 transition"
                    >
                        📥 Baixar Modelo de Importação
                    </a>
                </div>

                <input 
                    type="file" 
                    accept=".xlsx,.csv" 
                    onChange={handleFileChange} 
                    className="mb-4"
                />

                <button 
                    onClick={handleUpload} 
                    className="bg-blue-500 text-white px-4 py-2 rounded-lg hover:bg-blue-600 transition"
                    disabled={importando}
                >
                    {importando ? "Importando..." : "Enviar"}
                </button>
            </div>
        </div>
    );
};

export default ProductImport;
